import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'lodash';
import { DatePickerComponent } from '../components/inputs/selects/date-picker';
import { createRoot } from 'react-dom/client';


if (document.readyState === "complete") {
    renderDatePicker();
}
else {
    window.onload = renderDatePicker;
}

function renderDatePicker() {
    var elements = document.getElementsByClassName('date-picker');
    if (elements && elements.length > 0) {
        [].forEach.call(elements, element => {
            const root = createRoot(element);
            root.render(
                <DatePickerComponent
                    name={element.hasAttribute("data-name") ? element.attributes["data-name"].value : ""}
                    id={element.hasAttribute("data-id") ? element.attributes["data-id"].value : ""}
                    selectedDate={element.hasAttribute("selectedDate") ? element.attributes["selectedDate"].value : undefined}
                    startDate={element.hasAttribute("startDate") ? element.attributes["startDate"].value : ""}
                    endDate={element.hasAttribute("endDate") ? element.attributes["endDate"].value : ""}
                    customClasses={element.hasAttribute("customClasses") ? element.attributes["customClasses"].value : ""}
                    placeHolder={element.hasAttribute("placeholder-text") ? element.attributes["placeholder-text"].value : ""}
                     />
            );
        });
    }
}